import { useSession } from '~/contexts/SessionContext';
import { RoiId } from '~/domain/changes/ids';
import { createRoiDetailView } from '~/domain/projections/factories';
import { RoiDetailView } from '~/domain/projections/views';
import { useDomainProjection } from './useDomainProjection';

export function useRoiDetailView(
    id: RoiId | undefined
): RoiDetailView | undefined {
    return useDomainProjection(
        useSession(),
        'useRoiDetailView',
        [id],
        (patient) => {
            if (id === undefined) {
                return undefined;
            }
            for (const ss of patient.structureSets) {
                const roi = ss.getRoiById(id);
                if (roi) {
                    return createRoiDetailView(roi);
                }
            }
            return undefined;
        },
        undefined
    );
}
